const ContractInfo = {
  'pages_contract_ContractInfo.contractinfo': '계약 정보',
  'pages_contract_ContractInfo.totalTradeAmountByKrw': '전월 청구 비용',
  'pages_contract_ContractInfo.total': 'Total',
  'pages_contract_ContractInfo.includeVat': 'VAT 포함',
  'pages_contract_ContractInfo.trend': '월별 비용 트렌드',
  'pages_contract_ContractInfo.trend.month.bill': '월별 청구 비용',
  'pages_contract_ContractInfo.column.headerName.no': 'No.',
  'pages_contract_ContractInfo.column.headerName.accountId': 'Account ID',
  'pages_contract_ContractInfo.column.headerName.payment': '사용비용',
  'pages_contract_ContractInfo.column.headerName.all': '전체',
  'pages_contract_ContractInfo.column.headerName.customerName': '고객명',
  'pages_contract_ContractInfo.column.headerName.serviceIds': 'Account ID',
  'pages_contract_ContractInfo.column.headerName.invoiceMonth': '청구 월',
  'pages_contract_ContractInfo.column.headerName.id': '계약번호',
  'pages_contract_ContractInfo.column.headerName.contractName': '계약명',
  'pages_contract_ContractInfo.column.headerName.totalTradeAmountByKrw': '청구 비용(VAT 포함)',
  'pages_contract_ContractInfo.column.headerName.startDate': '시작일',
  'pages_contract_ContractInfo.column.headerName.endDate': '종료일',
  'pages_contract_ContractInfo.column.headerName.contractStatusName': '계약 상태',
  'pages_contract_ContractInfo.contract.ing': '계약 진행',
  'pages_contract_ContractInfo.contract.needextend': '계약 연장',
  'pages_contract_ContractInfo.contract.end': '계약 종료',
  'pages_contract_ContractInfo.contract.exceed': '종료 예정',

}

export default ContractInfo



// WEBPACK FOOTER //
// ./src/lang/contract/ContractInfo.kr.js